module.exports = __webpack_public_path__ + "img/Ola-Energy-Logo.007ee502.png";